import {FC, useState, useEffect} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Card, Row, Col, Image} from 'react-bootstrap'
import {getAllActivityLogs} from './core/_requests'
import useAxiosPrivate from '../../../libs/useAxiosPrivate'
import {ActivityLog} from './core/_models'
import {ActivityLogsTable} from './components/ActivityLogsTable'

const ActivityLogsPage: FC = () => {
  const axiosPrivate = useAxiosPrivate()
  const [isLoading, setIsLoading] = useState(false)
  const [tableData, setTableData] = useState<ActivityLog[]>([])

  const fetchActivityLogs = () => {
    setIsLoading(true)
    getAllActivityLogs(axiosPrivate)
      .then((res) => {
        if (res && res.data.data) {
          setTableData(res.data.data)
        }
      })
      .catch((e) => {
        console.error(e)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    fetchActivityLogs()
  }, [])

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Home', path: '/', isSeparator: false, isActive: false},
          {title: '', path: '', isSeparator: true, isActive: false},
        ]}
      >
        Activity Logs
      </PageTitle>
      <>
        <Row className='mb-5'>
          <Col>
            <Card className='card-custom card-border'>
              <Card.Body className='d-flex align-items-center'>
                <Image src='/media/tina/img-result-documents.jpg' thumbnail width={110} />
                <div className='ms-5 d-flex flex-column justify-content-center'>
                  <h3 className='text-primary'>Activity Logs</h3>
                  <div className='text-gray-700'>
                    View activity logs of system actions performed by administrators.
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className='mb-5'>
          <Col>
            <Card>
              <Card.Header className='card-header-stretch'>
                <Card.Title className='w-100'>
                  <div className='title-container w-100 d-flex justify-content-between align-items-center'>
                    <div className='title d-flex align-items-center'>
                      <span className='fa fa-history px-2'></span>
                      <h3 className='text-gray-700 m-0'>List Activity Logs</h3>
                    </div>
                  </div>
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <ActivityLogsTable rows={tableData} isLoading={isLoading} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </>
    </>
  )
}

export default ActivityLogsPage
